(() => {
  if (window.__raMobileCartInitialised) return;
  window.__raMobileCartInitialised = true;

  const isMobile = () => window.matchMedia('(max-width: 767px)').matches;
  let updateTimer = null;
  let lastCount = null;

  const cartUrl = () => `${window.Shopify?.routes?.root || '/'}cart.js`;

  const renderTitle = (count) => {
    const title = document.querySelector('#MinimogCartDrawer .m-cart-drawer__title');
    if (!title) return;

    let counter = title.querySelector('.ra-cart-count');
    if (!counter) {
      title.textContent = 'CARRELLO';
      counter = document.createElement('span');
      counter.className = 'ra-cart-count';
      title.appendChild(counter);
    }

    // Write only when the text changes: an identical write still mutates the DOM
    // and would re-trigger the drawer observer below (endless cart.js polling).
    const text = `(${count} ${count === 1 ? 'Articolo' : 'Articoli'})`;
    if (counter.textContent !== text) counter.textContent = text;
  };

  const quantityFallback = () => Array.from(
    document.querySelectorAll('#MinimogCartDrawer input[name="updates[]"]:not([disabled])')
  ).reduce((total, input) => total + (Number(input.value) || 0), 0);

  const updateCount = async () => {
    if (!isMobile()) return;

    const fallback = quantityFallback();
    if (fallback !== lastCount) {
      lastCount = fallback;
      renderTitle(fallback);
    }

    try {
      const response = await fetch(cartUrl(), { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      lastCount = Number(cart.item_count) || 0;
      renderTitle(lastCount);
    } catch (error) {}
  };

  const scheduleUpdate = () => {
    window.clearTimeout(updateTimer);
    updateTimer = window.setTimeout(updateCount, 120);
  };

  const start = () => {
    const drawer = document.getElementById('MinimogCartDrawer');
    // No drawer (cart page): there is no title to update, so no request is needed.
    // Already observed: the observer and events below keep the count current.
    if (!drawer || drawer.dataset.raCountObserver === 'true') return;
    drawer.dataset.raCountObserver = 'true';
    scheduleUpdate();

    // Only line-item changes can change the count; ignore the title, timers and widgets.
    const observer = new MutationObserver((mutations) => {
      const relevant = mutations.some((mutation) => {
        if (mutation.type === 'attributes') return mutation.attributeName === 'value';
        const target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
        return !!target?.closest('[data-minimog-cart-items]');
      });
      if (relevant) scheduleUpdate();
    });

    observer.observe(drawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value']
    });

    drawer.addEventListener('change', scheduleUpdate);
    drawer.addEventListener('click', (event) => {
      if (event.target.closest('.m-quantity__button, m-cart-remove-button')) {
        window.setTimeout(scheduleUpdate, 250);
        window.setTimeout(scheduleUpdate, 700);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.addEventListener('load', start);
  // Refresh only when entering the mobile layout, not on every resize
  // (mobile browsers fire resize while scrolling as the address bar moves).
  const mobileQuery = window.matchMedia('(max-width: 767px)');
  const onLayoutChange = (event) => { if (event.matches) scheduleUpdate(); };
  if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', onLayoutChange);
  else if (mobileQuery.addListener) mobileQuery.addListener(onLayoutChange);
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('cart:updated', scheduleUpdate);
  document.addEventListener('cart:refresh', scheduleUpdate);
})();

/* RA Boutique — load popup Bikini + Pareo Shine */
(() => {
  if (window.__raBikiniShineLoader) return;
  window.__raBikiniShineLoader = true;
  const current = document.currentScript && document.currentScript.src;
  if (!current) return;
  const script = document.createElement('script');
  script.src = current.replace(/ra-mobile-cart\.js(?:\?.*)?$/, 'ra-bikini-shine-popup.js?ra=1');
  script.defer = true;
  document.head.appendChild(script);
})();